// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fund-screener-menu {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  gap: 4px;
  padding: 8px 32px 0;
  flex-wrap: wrap;
}

.fund-screener-menu.small {
  padding: 8px 16px 0;
}

.fund-screener-menu-criteria-box {
  box-sizing: border-box;
  display: flex;
  flex: 1 0 0;
  min-width: 0;
  align-items: center;
  gap: 10px;
  height: 40px;
  padding: 8px 12px;
  background-color: var(--row-light);
  border: 1px solid var(--border-input);
  border-radius: 4px;
  cursor: pointer;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  &:hover {
    border: 1px solid var(--border-primary-brand);
  }
}

.fund-screener-menu-criteria-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.fund-screener-menu-criteria-icon path {
  fill: var(--text-instrument);
}

.fund-screener-menu-criteria-label {
  overflow: hidden;
  text-overflow: ellipsis;
}

.fund-screener-menu-refresh svg {
  width: 24px;
  height: 24px;
}

.fund-screener-menu-refresh svg path {
  fill: var(--color-brand);
}

.fund-screener-menu-reset-all {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  margin: 0;
  padding: 12px;
  flex-shrink: 0;
  background-color: var(--row-light);
  border: 1px solid var(--color-brand);
  border-radius: 4px;
  color: var(--color-brand);
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  white-space: nowrap;
  cursor: pointer;
  &:hover {
    background-color: var(--color-brand-hover2);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/FundScreener/FundScreenerMenu.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;EAClC,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,cAAc;EACd,kCAAkC;EAClC,oCAAoC;EACpC,kBAAkB;EAClB,yBAAyB;EACzB,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf;IACE,2CAA2C;EAC7C;AACF","sourcesContent":[".fund-screener-menu {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  position: relative;\n  gap: 4px;\n  padding: 8px 32px 0;\n  flex-wrap: wrap;\n}\n\n.fund-screener-menu.small {\n  padding: 8px 16px 0;\n}\n\n.fund-screener-menu-criteria-box {\n  box-sizing: border-box;\n  display: flex;\n  flex: 1 0 0;\n  min-width: 0;\n  align-items: center;\n  gap: 10px;\n  height: 40px;\n  padding: 8px 12px;\n  background-color: var(--row-light);\n  border: 1px solid var(--border-input);\n  border-radius: 4px;\n  cursor: pointer;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  &:hover {\n    border: 1px solid var(--border-primary-brand);\n  }\n}\n\n.fund-screener-menu-criteria-icon {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.fund-screener-menu-criteria-icon path {\n  fill: var(--text-instrument);\n}\n\n.fund-screener-menu-criteria-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.fund-screener-menu-refresh svg {\n  width: 24px;\n  height: 24px;\n}\n\n.fund-screener-menu-refresh svg path {\n  fill: var(--color-brand);\n}\n\n.fund-screener-menu-reset-all {\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  margin: 0;\n  padding: 12px;\n  flex-shrink: 0;\n  background-color: var(--row-light);\n  border: 1px solid var(--color-brand);\n  border-radius: 4px;\n  color: var(--color-brand);\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  white-space: nowrap;\n  cursor: pointer;\n  &:hover {\n    background-color: var(--color-brand-hover2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
